import React from 'react';
import { useSwiper } from 'swiper/react';
import { SliderArrowIcon } from '../../Icons';
import s from "./styles.module.scss";
import { SliderArrowProps } from './types';

const SliderPrevArrow: React.FC<SliderArrowProps> = ({className}) => {
  const swiper = useSwiper();

  return (
    <button onClick={() => swiper.slidePrev()}>
      <SliderArrowIcon className={`${s.arrow} ${s.prev} ${className ?? ''}`} />
    </button>
  );
};

export default SliderPrevArrow;